import React from "react";
import { Users, DollarSign, Calendar, TrendingUp } from "lucide-react";
import { Card } from "antd";
import { useNavigate } from "react-router-dom";

const DASHBOARD_CARDS = [
  {
    title: "Total Employees",
    value: "12",
    description: "Active team members",
    route: "/console/employee-details",
    icon: Users,
    iconBg: "flat-blue",
    gradient: "blue",
  },
  {
    title: "Monthly Payroll",
    value: "$312K",
    description: "+2.3% from last month",
    route: "",
    icon: DollarSign,
    iconBg: "flat-purple",
    gradient: "purple",
  },
  {
    title: "Attendance Rate",
    value: "90.5%",
    description: "Current month average",
    route: "/console/attendance-overview",
    icon: Calendar,
    iconBg: "flat-teal",
    gradient: "teal",
  },
  {
    title: "Training Completion",
    value: "78%",
    description: "156 courses completed",
    route: "/console/training-overview",
    icon: TrendingUp,
    iconBg: "flat-orange",
    gradient: "orange",
  },
];

const DashboardSummaryCard = () => {

  const navigate = useNavigate(); 
  
  const handleClick = (route) => {
    if (route) navigate(route);
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {DASHBOARD_CARDS.map((card, index) => {
        const Icon = card.icon;
        return (
        <Card
          key={index}
          onClick={() => handleClick(card.route)}
          className="text-card-foreground flex flex-col gap-6 rounded-xl cursor-pointer hover:shadow-lg transition-all border border-slate-200 dark:border-zinc-700 bg-white dark:bg-zinc-800"
        >
          <div className="flex flex-row items-center justify-between px-6 pt-6 pb-2">
            <h4 className="text-[14px] dark:text-zinc-100">{card.title}</h4>
            <div className={`p-2 bg-text ${card.iconBg}`}>
              <Icon className="w-4 h-4"/>
            </div>
          </div>
          <div className="px-6 pb-6">
            <div className={`text-[32px] font-semibold label-gradient ${card.gradient}`}>
              {card.value}
            </div>
            <p className="text-[12px]">{card.description}</p>
          </div>
        </Card>
         );
      })}
    </div>
  );
};

export default DashboardSummaryCard;
